import React, { useState } from 'react';
import Result from '../Result';
import EditBtn from '../EditBtn';
import EditForm from '../EditForm';

const ReadMode = ({ value, setMode }) => {
  return (
    <Result
      value={value}
      action={<EditBtn onClick={() => setMode('edit')} />}
    />
  );
};

const EditMode = ({ value, onChange, setMode, fieldProps }) => {
  const setReadMode = () => setMode('read');

  const handleOk = (value) => {
    onChange(value);
    setReadMode();
  };

  return (
    <EditForm
      value={value}
      onCancel={setReadMode}
      onOk={handleOk}
      fieldProps={fieldProps}
    />
  );
};

const EditableContent = ({ value, onChange, fieldProps }) => {
  const [mode, setMode] = useState('read');

  return mode === 'read' ? (
    <ReadMode value={value} setMode={setMode} />
  ) : (
    <EditMode
      value={value}
      setMode={setMode}
      onChange={onChange}
      fieldProps={fieldProps}
    />
  );
};

export default EditableContent;
